import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Field } from '../../model/field.interface';
import { FieldBuilder } from '../../tool/field.builder';
import type { FieldType } from '../../model/field-type.type';
import type { FieldView } from '../../model/field-view.type';

interface FieldTypeItem {
  readonly code: string;
  readonly name: string;
}

interface CommonField {
  readonly type : string;
  readonly label: string;
}

@Component({
  selector: 'app-field-group',
  templateUrl: './field-group.component.html',
  styleUrls: ['./field-group.component.scss'],
})
export class FieldGroupComponent {

  @Input() fields!: Field[];
  @Input() view: FieldView = 'fill';

  @Output() fieldsChange = new EventEmitter<Field[]>();

  protected expandedGuid: string = '';

  protected readonly commonFields: readonly CommonField[] = [
    { type: 'text'  , label: 'Prénom'                },
    { type: 'text'  , label: 'Nom'                   },
    { type: 'text'  , label: 'Ville'                 },
    { type: 'text'  , label: 'Adresse mail'          },
    { type: 'text'  , label: 'N° de téléphone'       },
    { type: 'number', label: 'Nombre de participant' },
  ];

  protected readonly fieldTypes: readonly FieldTypeItem[] = [
    { code: 'boolean'  , name: 'Oui / Non'   },
    { code: 'number'   , name: 'Nombre'      },
    { code: 'date'     , name: 'Date'        },
    { code: 'text'     , name: 'Texte court' },
    { code: 'long-text', name: 'Texte long'  },
    { code: 'list'     , name: 'Liste'       },
  ];

  addField(code: FieldType): void {
    const builder = new FieldBuilder();
    const newField: Field = builder.createField({ type: code });
    if (code === 'list') {
      while(newField.options.length < 2) {
        newField.options.push({ label: '' });
      }
    }
    this.fields.push(newField);
    this.expand(newField);
    this.fieldsChange.emit(this.fields);
  }
  removeField(index: number): void {
    this.fields.splice(index, 1);
    this.fieldsChange.emit(this.fields);
  }
  updateField(index: number, field: Field): void {
    this.fields[index] = field;
    this.fieldsChange.emit(this.fields);
  }

  down(index: number): void {
    if (index >= this.fields.length - 1) {
      return;
    }
    const field = this.fields[index];
    this.fields[index] = this.fields[index + 1];
    this.fields[index + 1] = field;
    this.fieldsChange.emit(this.fields);
  }
  up(index: number): void {
    if (index <= 0) {
      return;
    }
    const field = this.fields[index];
    this.fields[index] = this.fields[index - 1];
    this.fields[index - 1] = field;
    this.fieldsChange.emit(this.fields);
  }

  protected updateLabel(field: Field, label: string): void {
    field.label = label;
    this.fieldsChange.emit(this.fields);
  }

  protected collapse(field: Field): void {
    this.expandedGuid = '';
  }
  protected expand(field: Field): void {
    this.expandedGuid = field.guid;
  }

  protected getTypeName(code: FieldType): string {
    const type = this.fieldTypes.find(t => t.code === code);
    return type ? type.name : '';
  }

  protected isCollapsed(field: Field): boolean {
    return this.expandedGuid !== field.guid;
  }

}
